/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, HFlow, Text, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'

import { SimNaoRadioGroupField, SimNaoRadioGroupFieldProps } from './SimNaoRadioGroupField'

export enum SimNaoEnum {
  SIM = 'SIM',
  NAO = 'NAO',
}

interface SimNaoRadioGroupBoxFieldProps extends SimNaoRadioGroupFieldProps {
  label: string
  labelStyle?: ExternalStyles
}

export function SimNaoRadioGroupBoxField(props: Readonly<SimNaoRadioGroupBoxFieldProps>) {
  const { label, labelStyle, required, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Box style={styles.box}>
      <HFlow alignItems='center' justifyContent='space-between'>
        <Text>
          <Text style={[styles.text, labelStyle]}>{label}</Text>
          {required && <Text color='danger'> *</Text>}
        </Text>
        <SimNaoRadioGroupField hSpacing={0.5} required={required} {...rest} />
      </HFlow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  box: css`
    padding: 0.75rem 1rem;
  `,
  text: css`
    color: ${theme.pallete.primary.main};
    font-weight: bold;
  `,
})
